import React from "react";
import "../assests/CSS//ArticleComp2.css";
import { article2Data } from "./data";

const ArticleComp2 = () => {
  return (
    <div className="article-container">
      {article2Data.map((item, index) => (
        <React.Fragment key={item.id}>
          <div
            className={`article-card ${index % 2 === 0 ? "image-left" : "image-right"}`}
          >
            <div className="article-image">
              <img src={item.image} alt={item.title} />
            </div>
            <div className="article-content">
              <h3 className="article-title">{item.title}</h3>
              <p className="article-desc">{item.description}</p>
              <button className="article-btn">{item.buttonText}</button>
            </div>
          </div>
          {/* Divider only if not last card */}
          {index !== article2Data.length - 1 && <div className="divider"></div>}
        </React.Fragment>
      ))}
    </div>
  );
};

export default ArticleComp2;
